var map = {
	"./Dashboard.svg": "37bd",
	"./Platform-section-01-min.jpeg": "ba99",
	"./Platform-section-intelligence-image-03-min-768x508.webp": "242d",
	"./disc.svg": "b4ad",
	"./elementor-widget-icon.svg": "598e",
	"./enablement-list1-1.png": "92e0",
	"./enablement-list1-2.png": "be99",
	"./enablement-list1-3.png": "4c72",
	"./enablement-list1-4.png": "b8a7",
	"./enablement-list1-5.png": "6064",
	"./enablement-list1-6.png": "e26b",
	"./enablement-list1-7.png": "4702",
	"./enablement-list1-8.png": "56c3",
	"./enablement-list1-bg.png": "0858",
	"./end-to-end-operations.svg": "1fae",
	"./four-1.png": "e2a7",
	"./merchant-support.svg": "bf27",
	"./regulations-and-tax-compliance.svg": "b2d9",
	"./risk-management.svg": "7f46",
	"./self-management-tools.svg": "e394",
	"./send-map.svg": "1d0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f18";